module.exports = __webpack_public_path__ + "5c114213/img/comments-icon.fdec7fdb.svg";